import React from 'react'
import App from './src/App'

/**
 *
 */
const PayNow = (props) => <App {...props}/>

export default PayNow
